import { render, staticRenderFns } from "./SubmitWorkers.vue?vue&type=template&id=36b092e2&"
import script from "./SubmitWorkers.vue?vue&type=script&lang=js&"
export * from "./SubmitWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports